"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "6fc9293",
    "raw": "v3.9.0",
    "semverString": "3.9.0"
};
